import api from './api';

export interface NotificationPreferences {
  emailNotificationsEnabled: boolean;
  reviewRemindersEnabled: boolean;
  preferredReminderTime: string;
  timezone: string;
}

export interface SpacedRepetitionSettings {
  enabled: boolean;
  intervals: {
    again: number;
    hard: number;
    good: number;
    easy: number;
  };
  multipliers: {
    hard: number;
    good: number;
    easy: number;
  };
}

export interface HomeData {
  recentDecks: Array<{
    _id: string;
    name: string;
    description?: string;
    tags: string[];
    createdAt: string;
    updatedAt: string;
    cardCount?: number;
    lastStudied?: string;
  }>;
  recentQuizzes: Array<{
    _id: string;
    title: string;
    description?: string;
    deckId?: string;
    createdAt: string;
    updatedAt: string;
    questionsCount?: number;
    lastAttempted?: string;
  }>;
  recentQuizAttempts: Array<{
    _id: string;
    quizId: any;
    score: number;
    createdAt: string;
  }>;
  recentMatchGames: Array<{
    _id: string;
    title: string;
    description?: string;
    deckId?: string;
    createdAt: string;
    updatedAt: string;
    pairsCount?: number;
    lastAttempted?: string;
  }>;
  recentMatchAttempts: Array<{
    _id: string;
    matchGameId: any;
    score: number;
    createdAt: string;
  }>;
  recentStudies: Array<{
    _id: string;
    title: string;
    subject?: string;
    description?: string;
    status: string;
    priority: string;
    tags: string[];
    createdAt: string;
    updatedAt: string;
    start?: string;
    end?: string;
  }>;
}

export const userService = {
  async getProfile() {
    const response = await api.get('/users/profile');
    return response.data;
  },

  async getNotificationPreferences(): Promise<NotificationPreferences> {
    const response = await api.get('/users/notification-preferences');
    return response.data;
  },

  async updateNotificationPreferences(preferences: Partial<NotificationPreferences>) {
    const response = await api.put('/users/notification-preferences', preferences);
    return response.data;
  },

  async getHomeData(): Promise<HomeData> {
    const response = await api.get('/users/home-data');
    return response.data;
  },
};